import Box from '@mui/material/Box';

const revealedSx = {
  position: 'fixed',
  left: 16,
  top: 16,
  width: 'auto',
  height: 'auto',
  padding: 1,
  zIndex: 'modal',
  bgcolor: 'background.paper',
  color: 'text.primary',
  border: '2px solid',
  borderColor: 'primary.main',
  borderRadius: 1,
  textDecoration: 'none',
};

function SkipLink() {
  return (
    <Box
      component="a"
      href="#main"
      sx={{
        position: 'absolute',
        left: -9999,
        width: 1,
        height: 1,
        overflow: 'hidden',
        transition: 'top 0.2s ease-in-out',
        '@media (prefers-reduced-motion: reduce)': {
          transition: 'none',
        },
        '&:focus': revealedSx,
        '&:focus-visible': revealedSx,
      }}
    >
      Skip to main content
    </Box>
  );
}

export { SkipLink };
